import { render, staticRenderFns } from "./SysMessageTestModal.vue?vue&type=template&id=d647c708&scoped=true"
import script from "./SysMessageTestModal.vue?vue&type=script&lang=js"
export * from "./SysMessageTestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d647c708",
  null
  
)

export default component.exports